// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3rwuM","range":"MonthRangeSwitch_range__2JxTu","disabled":"MonthRangeSwitch_disabled__1NqDl"};